
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "6ea07b87c6aec225fc5e931f8ee7c00f30e04f06",
  "nuxt": {
    "buildId": "b04f6474-5f30-44f8-b802-27502419f1fc"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
